<sd-4-5-1-drawer
  #drawer
  (sd-show)="dokaVisible.set(true)"
  (sd-after-hide)="dokaVisible.set(false)">

  <ng-container
    #documents
    provideElements
    [documentId]="CUID.data"
    [reportIndex]="0"
    [funds]="funds()">

    <div class="content">
      <div class="header-section">

        @if (loading()) {
          <div class="header-section-placeholder wct-relative">
            <sd-4-5-1-spinner class="wct-absolute-center"></sd-4-5-1-spinner>
          </div>

        } @else {
          <wct-element-host [element]="'Header' | element | async"/>

          <div [class.redirection-buttons]="realestateFundstypeElement | element | async">
            <a href="{{ fondsportraitUrl() }}" (click)="interceptRedirect($event)">
              <sd-4-5-1-button [disabled]="!fondsportraitUrl()">
                {{ 'advancedFundList.openFondsportrait' | transloco }}
              </sd-4-5-1-button>
            </a>

            @if (realestateFundstypeElement | element | async) {
              <!-- sd-tooltip is currently broken in drawers as of 3.3.0 -->
                <!-- <span slot="content">{{ 'advancedFundList.realestateTooltip' | transloco }}</span> -->
              <a
                href="https://institutional-realestate.union-investment.de/de-DE/"
                target="_blank">

                <sd-4-5-1-button [disabled]="!fondsportraitUrl()">
                  {{ 'advancedFundList.openRealestate' | transloco }}
                </sd-4-5-1-button>
              </a>
            }
          </div>
        }

        <div #quicklinks class="quicklinks"></div>
      </div>

      <div
        wctLoadingIndicator
        [apiCallAdditionalLoading]="loading">

        <wct-element-host
          class="table"
          [hideIfNoElement]="false"
          [element]="'Block 3' | element | async"
          [options]="tableOptions">

          <div default class="content-table-placeholder"></div>

        </wct-element-host>
      </div>

      <div #subscriptionList></div>

      <div>
        <div>
          <strong>{{ 'advancedFundList.dokaHeader' | transloco }}</strong>
        </div>
        @if (dokaVisible()) {
          <wct-doka #doka [dokaOptions]="dokaOptions()"/>
        }
      </div>

    </div>

  </ng-container>
</sd-4-5-1-drawer>
